import { SourceCrawlerInterval, SourceCrawlerType } from './source.constants';
import { SourceResource } from './source.resource';
class SourceService {
    constructor() {
        this.sourceResource = new SourceResource();
    }
    create(source) {
        return this.sourceResource.create(source);
    }
    get(id) {
        return this.sourceResource.getSource(id);
    }
    getList(project) {
        return this.sourceResource.getList(project);
    }
    getCategoriesWithSources(project) {
        return this.sourceResource.getCategoriesWithSources(project);
    }
    update(source) {
        return this.sourceResource.update(source);
    }
    delete(id) {
        return this.sourceResource.deleteSource(id);
    }
    createDefaultSource(projectKey) {
        return {
            project: projectKey,
            key: '',
            name: '',
            category: '',
            crawlerMapping: undefined,
            crawlerOptions: {
                interval: SourceCrawlerInterval.H1,
                type: SourceCrawlerType.PANDA,
                sorting: null,
                subsource: null,
                feedKey: null,
            },
        };
    }
    createInstagramSource(sourceName) {
        return {
            flags: { popular: false, latest: true },
            title: sourceName,
            icon: 'https://storage.googleapis.com/panda-feed-icons/instagram.png',
            name: 'instagram',
            subsources: [
                {
                    displayName: sourceName,
                    name: sourceName,
                    sorting: { popular: false, latest: true },
                },
            ],
            articles: [],
        };
    }
}
export default new SourceService();
